import type { SVGProps } from 'react'

import { IconTemplateIPortIcon } from '../../template/IconTemplateIPortIcon'
import { CustomIconProps } from '../../types/types'

export const SvgTool = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplateIPortIcon {...props}>
			<svg viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.0452 15.8624L14.0565 16.851L4.5 10.5898L11.0907 3.99912L17.3519 13.5557L16.3633 14.5443L26.7482 24.9292C28.5577 23.7303 31.0197 23.928 32.6139 25.5223L39.2047 32.113C41.0246 33.933 41.0246 36.8838 39.2047 38.7037C37.3847 40.5237 34.4339 40.5237 32.6139 38.7037L26.0232 32.113C24.429 30.5188 24.2312 28.0568 25.4301 26.2473L15.0452 15.8624Z"
					fill="url(#paint0_linear_13561_60268)"
				/>
				<path
					d="M40.9858 11.3858C40.9723 11.3723 38.2428 14.0724 32.8107 19.4994L28.9992 15.6852L37.1205 7.55812C32.8466 4.98387 27.3561 5.64428 23.7961 9.2069C22.4352 10.568 21.4559 12.2632 20.9563 14.1225C20.4568 15.9818 20.8799 18.4823 21.3751 20.3428L21.456 20.6438L8.65158 33.45C8.37324 33.7285 8.51284 34.0575 8.79118 34.336L14.153 39.6985C14.4313 39.9771 14.7754 40.1315 15.0538 39.853L27.8581 27.0469L28.1589 27.1278C31.9165 28.1296 36.4785 27.5142 39.2799 24.7108C42.8444 21.1482 43.5043 15.6538 40.9858 11.3858Z"
					fill="#4A4A4A"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_13561_60268"
						x1="37.3247"
						y1="44.0736"
						x2="2.42551"
						y2="9.17442"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#5C90FC" />
						<stop offset="1" stopColor="#B7D2FF" />
					</linearGradient>
				</defs>
			</svg>
		</IconTemplateIPortIcon>
	)
}
